import { createI18n } from 'vue-i18n';
import es from './es';
import en from './en';

const saved = localStorage.getItem('sanatia_lang') || 'es';

export default createI18n({
  legacy: false,
  locale: saved,
  fallbackLocale: 'es',
  messages: { es, en },
});
